import { MappingEventTypes } from '@src/common/types/empTypes';
import { trimMappedEventRules } from '@src/components/mapping-panel/utils/trimUtils';

export type EventType =
  | 'flow-initial'
  | 'flow-complete'
  | 'metric-initial'
  | 'metric-complete'
  | 'metric-single'
  | 'metric-ratio-numerator'
  | 'metric-ratio-denominator';

const eventConfig: {
  [type in EventType]: {
    field: string;
    label: string;
  };
} = {
  'flow-initial': {
    field: 'initial_event',
    label: 'Initial Event',
  },
  'flow-complete': {
    field: 'complete_event',
    label: 'Complete Event',
  },
  'metric-initial': {
    field: 'initial_event',
    label: 'Initial Event',
  },
  'metric-complete': {
    field: 'complete_event',
    label: 'Complete Event',
  },
  'metric-single': {
    field: 'initial_event',
    label: 'Event',
  },
  'metric-ratio-numerator': {
    field: 'numerator_event',
    label: 'Numerator Event',
  },
  'metric-ratio-denominator': {
    field: 'denominator_event',
    label: 'Denominator Event',
  },
};

export function getEventConfigByType(type: EventType) {
  return eventConfig[type];
}

export function getEventParam(
  eventType: EventType,
  eventInfo,
): {
  event_field: string;
  event_ids: number[];
  unsaved_event_rules: Array<MappingEventTypes[][]>;
} {
  const { field: event_field } = getEventConfigByType(eventType);
  const event_ids: number[] = [];
  const unsaved_event_rules: Array<MappingEventTypes[][]> = [];
  const { event_id, rules } = eventInfo;
  if (event_id !== undefined) {
    event_ids.push(event_id);
  } else {
    // not id for raw events.
    const trimmedRules = trimMappedEventRules(rules);
    unsaved_event_rules.push(trimmedRules);
  }
  return {
    event_field,
    event_ids,
    unsaved_event_rules,
  };
}
